import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export { BACKEND_URL };

export const api = axios.create({ baseURL: API });

// Authorized instance for admin — injects Bearer token from localStorage
export const authApi = axios.create({ baseURL: API });
authApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("ping_admin_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);

/**
 * Resolve an image path from the /admin/upload endpoint into a full URL.
 * - New Cloudinary uploads return absolute https:// URLs → returned as-is.
 * - Legacy uploads return a relative /api/images/{id} path → prefix with
 *   backend origin so <img src> can load them.
 */
export const resolveImageUrl = (pathOrUrl) => {
  if (!pathOrUrl) return "";
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  return `${BACKEND_URL}${pathOrUrl}`;
};

/**
 * Normalise any YouTube/Vimeo URL a user might paste into an admin field
 * into the embed-friendly form. Iframes cannot load a plain
 * https://www.youtube.com/watch?v=... URL — they require the /embed/ path.
 * If the URL is already an embed link, returns it unchanged.
 */
export const toEmbedUrl = (url) => {
  if (!url) return "";
  const trimmed = url.trim();
  // Already an embed URL
  if (/\/embed\//.test(trimmed)) return trimmed;
  // youtu.be/<id>
  const shortMatch = trimmed.match(/youtu\.be\/([\w-]+)/i);
  if (shortMatch) return `https://www.youtube.com/embed/${shortMatch[1]}`;
  // youtube.com/watch?v=<id>
  const watchMatch = trimmed.match(/[?&]v=([\w-]+)/);
  if (watchMatch) return `https://www.youtube.com/embed/${watchMatch[1]}`;
  // youtube.com/shorts/<id>
  const shortsMatch = trimmed.match(/youtube\.com\/shorts\/([\w-]+)/i);
  if (shortsMatch) return `https://www.youtube.com/embed/${shortsMatch[1]}`;
  // Vimeo — https://vimeo.com/<id>
  const vimeoMatch = trimmed.match(/vimeo\.com\/(\d+)/i);
  if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
  return trimmed;
};
